import { z } from 'zod'

export default z.object({
  __typename: z.literal('Person').default('Person'),
  id: z.string(),
})
